import { useState, useEffect, useContext } from "react";
import Select from 'react-select';
import ContextStates from "../context/ContextStates";
import axios from "axios";
import { Url } from "./Url";



const Filtros = () => {
    const { zonas, setZonas, zona, setZona, fechaInicio, setFechaInicio, fechaFin, setFechaFin, usuario, setUsuario, usuarios, setUsuarios, buscarCliente, setBuscarCliente } = useContext(ContextStates)

    useEffect(() => {
        const consultaZonas = async () => {
            const formData = new FormData()
            formData.append("id", 1)
            formData.append("activo", 1)
            try {
                const response = await axios({
                    url: Url + 'api/listZonas.php',
                    method: 'POST',
                    data: formData,
                })

                setZonas(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaZonas()
    }, [])

    useEffect(() => {
        const consultaUsuarios = async () => {
            const formData = new FormData()
            formData.append("usuariocero", 1)
            try {
                const response = await axios({
                    url: Url + 'api/listUsrs.php',
                    method: 'POST',
                    data: formData,
                })

                setUsuarios(response.data.results)
            } catch (e) {
                console.log(e)
            }
        }
        consultaUsuarios()
    }, [])


    return (
        <div className="w-full">
            <div className='bg-gradient-to-br from-blue-50 to-indigo-100 rounded-xl shadow-md p-6'>
                {/* Título */}
                <h2 className="text-xl font-bold text-gray-800 mb-6 text-center">Filtros de Búsqueda</h2>

                {/* Grid de Filtros */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    {/* Zona */}
                    <div className="space-y-2">
                        <label className="block text-sm font-semibold text-gray-700">
                            📍 Zona
                        </label>
                        <Select
                            options={zonas}
                            value={zona === 0 ? null : zona}
                            placeholder="Seleccione la zona"
                            onChange={(value) => setZona(value)}
                            name='sZona'
                            className="shadow-sm"
                        />
                    </div>

                    {/* Usuario */}
                    <div className="space-y-2">
                        <label className="block text-sm font-semibold text-gray-700">
                            👤 Usuario
                        </label>
                        <Select
                            options={usuarios}
                            value={usuario === 0 ? null : usuario}
                            placeholder="Seleccione el usuario"
                            onChange={(value) => setUsuario(value)}
                            name='sUsuario'
                            className="shadow-sm"
                        />
                    </div>

                    {/* Fecha de Inicio */}
                    <div className="space-y-2">
                        <label htmlFor='fechainicio' className="block text-sm font-semibold text-gray-700">
                            📅 Fecha de Inicio
                        </label>
                        <input
                            type='date'
                            className='w-full p-3 rounded-lg border border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all'
                            id='fechainicio'
                            value={fechaInicio}
                            onChange={(e) => setFechaInicio(e.target.value)}
                        />
                    </div>

                    {/* Fecha de Fin */}
                    <div className="space-y-2">
                        <label htmlFor='fechafin' className="block text-sm font-semibold text-gray-700">
                            📅 Fecha de Fin
                        </label>
                        <input
                            type='date'
                            className='w-full p-3 rounded-lg border border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all'
                            id='fechafin'
                            value={fechaFin}
                            onChange={(e) => setFechaFin(e.target.value)}
                        />
                    </div>
                    {/* Búsqueda por Cliente */}
                    <div className="space-y-2 md:col-span-2">
                        <label htmlFor='buscarCliente' className="block text-sm font-semibold text-gray-700">
                            🔍 Buscar Cliente
                        </label>
                        <input
                            type='text'
                            id='buscarCliente'
                            className='w-full p-3 rounded-lg border border-gray-300 shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all'
                            placeholder='Apellido o nombre del cliente...'
                            value={buscarCliente}
                            onChange={(e) => setBuscarCliente(e.target.value)}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Filtros
